"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 翻译工具类
 * @author kurthe
 * @description 由于需要填充语言包数据，使用类实现导致该文件是一个副作用文件，无法 treeshaking
 */
var Cookie = __importStar(require("./cookies"));
var QueryString = __importStar(require("./query-string"));
var type_1 = require("./type");
var isBrowser = typeof document !== 'undefined';
var I18n = /** @class */ (function () {
    function I18n() {
    }
    /**
     * 获取当前语言环境
     * @order lang(cookie) > lang(query string) > navigator  > en(default)
     */
    I18n.getCurrentLanguage = function (lang) {
        if (lang) {
            return lang;
        }
        if (!isBrowser) {
            return '';
        }
        return (Cookie.get('lang')
            || QueryString.parse(window.location.hash.split('?')[1]).lang
            || this.LanguageMap.get(navigator.language.toLowerCase())
            || 'en');
    };
    /**
     * 初始化翻译表
     * @param map 翻译平台数据
     */
    I18n.init = function (map) {
        if (window.WESING_MATERIAL) {
            window.WESING_MATERIAL.languageData = map;
        }
        else {
            window.WESING_MATERIAL = {
                languageData: map,
            };
        }
    };
    I18n.translate = function (languageData, key, lang) {
        if ((0, type_1.isUndefined)(key) || (0, type_1.isUndefined)(languageData)) {
            return '';
        }
        var regexp = /%([\w\s]+)%/g;
        var value;
        var result = key;
        var language = this.getCurrentLanguage(lang);
        // 如果当前语言不存在「语言数据」里面，则降级取 en
        var languageInfo = languageData[language] || languageData.en;
        if (!languageInfo) {
            return result;
        }
        while ((value = regexp.exec(key))) {
            var replaceKey = value[0], translationKey = value[1];
            var transitionValue = languageInfo[translationKey] || languageData.en[translationKey];
            if (transitionValue) {
                result = result.replace(replaceKey, transitionValue);
            }
        }
        return result;
    };
    /**
     * 根据传递的文本，获取翻译字符串
     * @param key 翻译词 key
     */
    I18n.translateByKey = function (key, lang) {
        var languageData = window.WESING_MATERIAL
            ? window.WESING_MATERIAL.languageData
            : window.WESING_MATERIAL;
        if (!languageData) {
            return key;
        }
        return this.translate(languageData, key, lang);
    };
    I18n.LanguageMap = new Map([
        ['th', 'th'],
        ['ms', 'ms'],
        ['ph', 'ph'],
        ['vi', 'vi'],
        ['en', 'en'],
        ['en-ph', 'ph'],
        ['zh', 'zh_Hans'],
        ['zh-hk', 'zh_Hant'],
        ['zh-tw', 'zh_Hant'],
        ['zh-cn', 'zh_Hans'],
        ['zh-sg', 'zh_Hans'],
    ]);
    return I18n;
}());
exports.default = I18n;
